export default "__VITE_ASSET__Bsu$3r0w__"